import dayjs from "dayjs";

export const formatCurrency = (value: number) =>
  new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
    maximumFractionDigits: 0,
  }).format(value);

export const formatDateTime = (value?: string) =>
  value ? dayjs(value).format("DD/MM/YYYY HH:mm") : "--";

export const formatLongDateTime = (value?: string) =>
  value
    ? new Intl.DateTimeFormat("vi-VN", {
        dateStyle: "medium",
        timeStyle: "short",
      }).format(new Date(value))
    : "--";

export const formatCountdown = (valueMs: number) => {
  const totalSeconds = Math.max(Math.floor(valueMs / 1000), 0);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return [hours, minutes, seconds]
      .map((value) => String(value).padStart(2, "0"))
      .join(":");
  }

  return [minutes, seconds]
    .map((value) => String(value).padStart(2, "0"))
    .join(":");
};

export const formatDate = (value?: string) =>
  value ? dayjs(value).format("DD/MM/YYYY") : "--";

export const formatWeightGram = (value?: number) =>
  typeof value === "number"
    ? `${new Intl.NumberFormat("vi-VN", {
        maximumFractionDigits: 2,
      }).format(value)}g`
    : "--";
